import { palette } from "../theme";
import { sceneConfig, sculptureRows } from "../config/scene";
import { glyphs } from "./glyphs";

export interface Voxel {
	x: number;
	y: number;
	z: number;
	w: number;
	h: number;
	color: string;
	href?: string;
	linkLabel?: string;
}
export const destinations: Voxel[] = [];
for (const row of sculptureRows) {
	const letters = [...row.text].map((c) => {
		const glyph =
			glyphs[c] ?? glyphs[c.normalize("NFD").replace(/\p{M}/gu, "")];
		if (!glyph)
			throw new Error(
				`Missing glyph: ${c}. Add it to src/scene/glyphs.ts.`,
			);
		return glyph;
	});
	const width =
		letters.reduce(
			(w, g) => w + g[0].length + sceneConfig.sculpture.letterSpacing,
			0,
		) - sceneConfig.sculpture.letterSpacing;
	let offset = -width / 2;
	for (const g of letters) {
		// Keep the small email lettering shallow, so its sides do not obscure the glyphs.
		for (let y = 0; y < g.length; y++)
			for (let x = 0; x < g[y].length; x++)
				if (g[y][x] === "1") {
					for (
						let depth = 0;
						depth <
						(row.depthLayers ??
							sceneConfig.sculpture.defaultDepthLayers);
						depth++
					)
						destinations.push({
							x: (offset + x + 0.5) * row.step,
							y: row.base + (g.length - 1 - y + 0.5) * row.step,
							z:
								row.z +
								(depth -
									((row.depthLayers ??
										sceneConfig.sculpture
											.defaultDepthLayers) -
										1) /
										2) *
									row.step,
							w: row.step * sceneConfig.sculpture.voxelFillRatio,
							h: row.step * sceneConfig.sculpture.voxelFillRatio,
							color: palette[row.color],
							href: row.href,
							linkLabel: row.linkLabel,
						});
				}
		offset += g[0].length + sceneConfig.sculpture.letterSpacing;
	}
}
